import React from "react";

export default function Versao1014() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-black mt-8">
        Histórico – Versão 1.0.14
      </h2>

      <ul className="space-y-4 text-black text-base leading-relaxed">
        <li>
          <strong>📅 Tela de Agendamentos:</strong>
          <p className="ml-4">
            A tela de agendamentos foi totalmente corrigida e agora está
            funcionando perfeitamente! 🎉 O sistema permite criar, editar e
            salvar agendamentos sem erros.
          </p>
        </li>

        <li>
          <strong>🧑‍🔧 Tabela de Chamados:</strong>
          <p className="ml-4">
            Correção aplicada no campo de pesquisa por <strong>Técnico</strong>.
            Agora o filtro funciona corretamente ao digitar o nome do técnico
            responsável pelo chamado. 🔍✅
          </p>
        </li>
      </ul>
    </div>
  );
}
